document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav toggle */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var header = document.querySelector('[data-site-header]');
  if (navToggle && header) {
    navToggle.addEventListener('click', function () {
      header.classList.toggle('is-menu-open');
    });
  }

  /* Quantity steppers */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    plus && plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* Purchase option (one-time vs subscribe & save) */
  document.querySelectorAll('[data-purchase-options]').forEach(function (wrap) {
    var options = wrap.querySelectorAll('[data-purchase-option]');
    var sellingPlanInput = wrap.querySelector('[data-selling-plan-input]');
    var submitLabel = wrap.querySelector('[data-submit-label]');
    var priceEl = document.getElementById('ProductPrice');

    function updatePrice(price) {
      if (priceEl && price) priceEl.textContent = price;
    }

    function select(option) {
      options.forEach(function (o) { o.classList.remove('is-selected'); });
      option.classList.add('is-selected');
      var isSubscribe = option.getAttribute('data-type') === 'subscribe';
      var planId = option.getAttribute('data-selling-plan-id');
      if (sellingPlanInput) {
        if (isSubscribe && planId) {
          sellingPlanInput.value = planId;
          sellingPlanInput.disabled = false;
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }
      if (submitLabel) {
        submitLabel.textContent = option.getAttribute('data-submit-text') || submitLabel.textContent;
      }
      if (!isSubscribe) {
        updatePrice(option.getAttribute('data-price'));
      } else {
        var activePill = option.querySelector('[data-frequency-pill].is-active') || option.querySelector('[data-frequency-pill]');
        if (activePill) updatePrice(activePill.getAttribute('data-price'));
      }
    }

    options.forEach(function (option) {
      option.addEventListener('click', function (e) {
        if (e.target.closest('[data-frequency-pill]')) return;
        select(option);
      });
    });

    /* Frequency pills inside the subscribe option */
    wrap.querySelectorAll('[data-frequency-pill]').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.stopPropagation();
        var group = pill.closest('[data-purchase-option]');
        group.querySelectorAll('[data-frequency-pill]').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var planId = pill.getAttribute('data-selling-plan-id');
        if (sellingPlanInput && planId) sellingPlanInput.value = planId;
        select(group);
        updatePrice(pill.getAttribute('data-price'));
      });
    });
  });

});
